import Vue from "vue"
import IAuthenticationMethod, {AuthenticationMethodState} from "@/managers/authentication/iauthenticationMethod"

export default abstract class AuthenticationMethodBase extends EventTarget implements IAuthenticationMethod {
	private readonly state = Vue.observable({current: AuthenticationMethodState.Uninitialized})

	public get currentState(): AuthenticationMethodState {
		return this.state.current
	}

	public get currentStateName(): string {
		return AuthenticationMethodState[this.state.current]
	}

	public get isLoggingIn(): boolean {
		return this.currentState === AuthenticationMethodState.LoggingIn
	}

	public get canLogin(): boolean {
		return this.currentState === AuthenticationMethodState.CanLogin
	}

	protected constructor(canLogin: boolean | null = null) {
		super()
		if (canLogin !== null)
			this.setCanLogin(canLogin)
	}

	protected setCanLogin(canLogin: boolean): void {
		this.state.current = canLogin ?  AuthenticationMethodState.CanLogin : AuthenticationMethodState.CannotLogin
	}

	protected setLoggingIn(): void {
		this.state.current = AuthenticationMethodState.LoggingIn
	}
}

export {AuthenticationMethodState}
